<ga-card
  class="tw:relative tw:w-72 tw:h-52"
  [ngClass]="{ 'tw:pointer-events-none tw:opacity-60': isCardDisabled }"
  [selectable]="!isCardDisabled"
  (click)="!isCardDisabled && clickCard.emit()"
>
  <div class="tw:items-start tw:justify-between tw:relative tw:flex tw:w-full tw:h-full tw:p-8">
    <div class="tw:mr-3 tw:flex-1">
      <div class="tw:items-center tw:flex tw:mb-3">
        <span class="tw:w-10 tw:h-10 tw:block tw:bg-cover tw:mr-3 tw:shrink-0" role="img" [ngClass]="iconClass"></span>
        <h3 class="tw:m-0"><ng-content select="di-grid-card-title" /></h3>
      </div>
      <ng-content select="di-grid-card-desc" />
    </div>
    @if (!isExternalLink && !isCardDisabled) {
      <ga-icon class="tw:shrink-0 tw:self-center" role="button" [icon]="icons.ChevronRight" />
    }
    @if (isExternalLink && !isCardDisabled) {
      <ga-icon class="tw:absolute tw:top-1.5 tw:right-2" role="button" [icon]="icons.ExternalLink" />
    }
  </div>
  @if (isCardDisabled) {
    <ga-icon
      class="tw:absolute tw:top-1.5 tw:right-2"
      data-testid="info-icon"
      [gaTooltip]="functionDisabledTooltip"
      [icon]="icons.Info"
    />
  }
</ga-card>
<ng-template #functionDisabledTooltip>
  <span i18n>Sorry, this function is temporarily disabled. Please try again later.</span>
</ng-template>
